import { render } from "./BoardArticlesTeacher.vue?vue&type=template&id=b20e8220"
import script from "./BoardArticlesTeacher.vue?vue&type=script&lang=js"
export * from "./BoardArticlesTeacher.vue?vue&type=script&lang=js"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__